<template>
    <form method="POST" v-on:submit.prevent="handleSubmit">
        <div class='m-portlet__body'>
            <Options :options="options" v-bind:softdelete="'0'" :inputs="inputs" v-on:updateOptions="updateOptions"></Options>
        </div>
        <Buttons v-on:save="save" :list-link="`/admin/modules/index`"></Buttons>
    </form>
</template>

<script>
import Buttons from '../../core/form/Buttons'
import Options from '../../core/module/Options'
export default {
  name: 'ModuleUpdateResource',
  components: {Options, Buttons},
  data () {
    return {
      options: {
        extra: []
      },
      inputs: {}
    }
  },
  methods: {
    updateOptions (variable) {
      this.options = Object.assign({}, variable)
    },
    handleSubmit () {
      let searchColumns = {}
      let searchColumnLabels = {}
      let resource = []
      let showList = []

      for (let it in this.options.extra) {
        if (this.options.extra[it].searchColumns) {
          searchColumns[this.options.extra[it].name] = this.options.extra[it].searchType
          searchColumnLabels[this.options.extra[it].name] = this.options.extra[it].searchColumnLabels
        }
        if (this.options.extra[it].show_list) {
          showList.push(this.options.extra[it].name)
        }

        if (this.options.extra[it].resource) {
          resource.push(this.options.extra[it].name)
        }
      }

      this.$http
        .put(process.env.API_URL + `/api/v1/admin/module-builder/update-resource`, {
          model: this.$route.params.id,
          resource: resource,
          show_list: showList,
          searchColumns: searchColumns,
          searchColumnLabels: searchColumnLabels,
          moduleName: this.$route.params.id
        }, {
          'headers': {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          if (res.data && res.data.data !== 'undefined') {
            this.$router.push('/admin/modules/index')
          } else {
            this.errors = res.response.data.errors
          }
        }).catch(res => {

        })
    }
  },
  mounted: function () {
    this.$emit('updateTitle', 'Update Resource: ' + this.$route.params.id)

    let self = this
    this.$http
      .get(process.env.API_URL + `/api/v1/admin/module-builder/show/${this.$route.params.id}`, {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        self.inputs = res.data.data[this.$route.params.id].fillable
        this.options.softdeletes = res.data.data[this.$route.params.id].softdelete
        for (let it in res.data.data[this.$route.params.id].fillable) {
          let resource = 0
          for (let xit in res.data.data[this.$route.params.id].resource) {
            if (res.data.data[this.$route.params.id].resource[xit] === res.data.data[this.$route.params.id].fillable[it]) {
              resource = 1
            }
          }

          let showList = 0
          for (let xit in res.data.data[this.$route.params.id].show_list) {
            if (res.data.data[this.$route.params.id].show_list[xit] === res.data.data[this.$route.params.id].fillable[it]) {
              showList = 1
            }
          }

          let sT = ''
          let sc = 0
          for (let xit in res.data.data[this.$route.params.id].searchColumns) {
            if (xit === res.data.data[this.$route.params.id].fillable[it]) {
              sT = res.data.data[this.$route.params.id].searchColumns[xit]
              sc = 1
            }
          }

          let scL = ''
          for (let xit in res.data.data[this.$route.params.id].searchColumnLabels) {
            if (xit === res.data.data[this.$route.params.id].fillable[it]) {
              scL = res.data.data[this.$route.params.id].searchColumnLabels[xit]
            }
          }

          this.options.extra.push({
            name: res.data.data[this.$route.params.id].fillable[it],
            resource: resource,
            searchColumnLabels: scL,
            searchColumns: sc,
            searchType: sT,
            show_list: showList
          })
        }
      }).catch(res => {

      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/module/ModuleUpdateResource.vue